import request from '@/service/lib/request'

/**
 * 移动采集 - 类别
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function getTypes(id) {
  return request({
    url: `/api/v1/companies/${id}/surveys/types`,
    method: 'get'
  })
}

/**
 * 移动采集 - 列表
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function list(companyId, type, params) {
  return request({
    url: `/api/v1/companies/${companyId}/surveys/${type}`,
    method: 'get',
    params
  })
}

/**
 * 移动采集 - 删除
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function remove(type, id) {
  return request({
    url: `/api/v1/surveys/${type}/${id}`,
    method: 'delete'
  })
}
